import { render, staticRenderFns } from "./DocAccordionMenu.vue?vue&type=template&id=699f1ebe"
import script from "./DocAccordionMenu.vue?vue&type=script&lang=js"
export * from "./DocAccordionMenu.vue?vue&type=script&lang=js"
import style0 from "./DocAccordionMenu.vue?vue&type=style&index=0&id=699f1ebe&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports